export const CLASS_NAME = 'cst-dashboard-card-year-flux'
